import React from 'react';
import HamHeader from '../../Header/HamburgerHeader';
import cn from 'classnames';
import style from '../sensors.module.scss';
import QrScanComp from '../../Common/QrScanComp';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const NamedSensorHeader = ({ namedFieldValue, setNamedFieldValue }) => (
  <div className="col-12 d-flex align-items-center justify-content-center px-0">
    <div className={cn(style.nameOfSensor, 'col-12')}>
      <div className="fw-500">{FLABEL().NAMED_SENSOR_NAME_OF_SENSOR}</div>
      <input
        type="text"
        value={namedFieldValue || ''}
        onChange={e => setNamedFieldValue(e.target.value)}
        className={cn(style.nameSensorInput, 'col-12 pl-3 pr-5')}
        placeholder={FLABEL().NAMED_ENTER_NAME}
      />
    </div>
  </div>
);

const SensorGroupsList = ({
  sensorGroupsList,
  group,
  setGroup,
  selectedSensorTab,
  showQRSection,
}) => (
  <>
    <div className="fw-500 pb-2">{FLABEL().TABLE_SENSOR_SENSOR_GROUP}</div>
    <div className={style.subTitle}>{FLABEL().TABLE_SENSOR_SELECTION}</div>

    <div
      className={cn(
        style.sensorGrpsWrapper,
        { [style.sensorGrpsWrapper_3]: showQRSection },
        { [style.sensorGrpsWrapper_named]: selectedSensorTab === 'named' },
        'd-flex flex-column align-items-stretch col-12 px-0'
      )}
    >
      {sensorGroupsList.map(sensorGrp => (
        <div key={sensorGrp.id}>
          <div
            className={cn(
              style.sensorGrpName,
              'd-flex align-items-center justify-content-center p-3 w-100'
            )}
            style={{
              border:
                sensorGrp.id === group?.id
                  ? '2px solid var(--primary-selection-color)'
                  : '2px solid transparent',
            }}
            onClick={() => setGroup(sensorGrp)}
          >
            {sensorGrp.name}
          </div>
        </div>
      ))}
    </div>
  </>
);

const RegisterNamedSensor = ({
  setPopup,
  sensorGroupsList,
  setGroup,
  group,
  setCodeValue,
  showQRSection,
  setShowQRSection,
  selectedSensorTab,
  namedFieldValue,
  setNamedFieldValue,
  checkDuplicate,
}) => {
  const extractQRCode = qrLink => {
    if (!qrLink) return '';
    return qrLink?.includes('?')
      ? qrLink.split('=').pop()
      : qrLink.split('/').pop();
  };

  const handleQRScan = data => {
    if (data?.includes('/s/')) {
      const scanCode = extractQRCode(data);
      setCodeValue(scanCode);
      if (scanCode) {
        checkDuplicate(scanCode);
        setPopup({ type: 'Add Sensor' });
      }
    }
  };

  const handleBack = () => {
    setPopup(null);
    setNamedFieldValue('');
    setGroup(null);
  };

  return (
    <div className={cn(style.RegisterSensor, 'h-100 p-3')}>
      <div className="mb-3">
        <HamHeader
          label={
            showQRSection
              ? FLABEL().HEADER_ADDSENSOR
              : FLABEL().HEADER_SENSORGROUP
          }
          onClickback={handleBack}
        />
      </div>

      <div className={cn(style.registerContainer, 'col-12 px-0')}>
        <div
          className={cn(
            'd-flex h-100',
            !showQRSection &&
              'flex-column align-items-center justify-content-center'
          )}
        >
          {/* LEFT SIDE - Sensor Group + Input */}
          <div className={cn(showQRSection ? 'col-4 px-0' : 'col-8')}>
            <NamedSensorHeader
              namedFieldValue={namedFieldValue}
              setNamedFieldValue={setNamedFieldValue}
            />

            <div className={cn(style.sensorGrpsContainer, style.sensorGrps_2)}>
              <SensorGroupsList
                sensorGroupsList={sensorGroupsList}
                group={group}
                setGroup={setGroup}
                selectedSensorTab={selectedSensorTab}
                showQRSection={showQRSection}
              />

              {!showQRSection && (
                <div className="d-flex gap-2 pt-3">
                  <div className="col-6 pl-0 pr-2">
                    <button
                      className={cn(style.Secondarybtn, 'col-12 fw-500')}
                      onClick={() => setGroup(null)}
                    >
                      {FLABEL().TABLE_SENSOR_CLEAR}
                    </button>
                  </div>
                  <div className="col-6 pr-0 pl-2">
                    <button
                      className={cn(
                        style.primaryBtn,
                        (String(namedFieldValue).trim().length === 0 ||
                          !group) &&
                          style.disabled,
                        'col-12 fw-500'
                      )}
                      disabled={
                        String(namedFieldValue).trim().length === 0 || !group
                      }
                      onClick={() => setShowQRSection(true)}
                    >
                      {FLABEL().TABLE_SENSOR_ADDQR}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* RIGHT SIDE - QR Scanner */}
          {showQRSection && (
            <div className="col-8 px-3">
              <div
                className={cn(
                  style.sensorGrpsContainer,
                  'd-flex flex-column align-items-center justify-content-center'
                )}
              >
                <div className="text-center pb-3 h-15">
                  {FLABEL().TABLE_SENSOR_FIT_BARCODE}
                </div>
                <div
                  className={cn(
                    style.qrScannerBg,
                    'col-10 p-5 d-flex flex-column align-items-center justify-content-center h-70'
                  )}
                >
                  <QrScanComp handleScan={handleQRScan} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterNamedSensor;
